import { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LegacyI18nContext } from '@bingads-webui-react/legacy-i18n-context';

export default function useI18nContext() {
  const i18n = useContext(I18nContext);
  const legacyI18n = useContext(LegacyI18nContext);

  return { i18n, legacyI18n };
}
